export function getSelf(obj) {
    if (obj) {
        return obj['_links']['self']['href'];
    }
}